import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfigService, UserItems } from '../../services/config.service';
import { filter } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { DatePipe } from '@angular/common';
import { UserEventsService } from '../../services/user-events/user-events.service';
import { Subscription } from 'rxjs';
import { UserConfigFacade } from 'src/app/state/user-config/user-config.facade';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
})
export class UserMenuComponent implements OnInit, OnDestroy {
  private userEventsSubscription?: Subscription;
  private userNotificationsSubscription?: Subscription;

  isMenuOpen = true;
  userItems: UserItems[] = [];
  userNotificationsCount: number = 0;
  userEventsCount: number = 0;
  isPendingNotifications: boolean;

  constructor(
    private readonly authService: AuthService,
    private readonly configService: ConfigService,
    private readonly datePipe: DatePipe,
    private readonly userEventsService: UserEventsService,
    private readonly userConfigFacade: UserConfigFacade
  ) {
  }

  ngOnInit() {
    this.userItems = this.configService.userItems;

    this.userEventsSubscription = this.userEventsService.userEvents$
      .pipe(filter(value => value !== null))
      .subscribe((userEvents) => {
        const currentDayWithFormat = String(this.datePipe.transform(new Date(), 'yyyy-MM-dd'));

        this.userEventsCount = userEvents.dayEvents.filter((event) => {
          return this.datePipe.transform(new Date(event.date), 'yyyy-MM-dd') === currentDayWithFormat && event.events.length > 0;
        }).length;
      });

    if (this.authService.isAuthenticated()) {
      this.userNotificationsSubscription = this.userConfigFacade.pendingNotifications$.subscribe(
        (pendingNotifications) => this.isPendingNotifications = pendingNotifications);
    }
  }

  ngOnDestroy() {
    this.userEventsSubscription?.unsubscribe();
    this.userNotificationsSubscription?.unsubscribe();
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }
}
